import Vue from 'vue';
import Router from 'vue-router';

import HomeConsumer from '@/views/HomeConsumer.vue';
import HomeAdmin from '@/views/HomeAdmin.vue';
import AlermHistory from '@/views/AlermHistory.vue';
import Login from '@/views/Login.vue';
import TrendGraph from '@/views/TrendGraph.vue';
import MonthlyReport from '@/views/MonthlyReport.vue';
import CompressorInfo from '@/views/CompressorInfo.vue';
import GroupingSetting from '@/views/GroupingSetting.vue';
import MachineNumberSetting from '@/views/MachineNumberSetting.vue';
import AlermMailSetting from '@/views/AlermMailSetting.vue';
import InfoSetting from '@/views/InfoSetting.vue';
import MaintenanceHistory from '@/views/MaintenanceHistory.vue';
import VolumeGraph from '@/views/VolumeGraph.vue';
import DashboardAdmin from '@/views/DashboardAdmin.vue';
import ConsumerMap from '@/views/ConsumerMap.vue';
import Logs from '@/views/Logs.vue';

import NotFound from '@/views/NotFound.vue';

import store from '@/store/index';

Vue.use(Router);

const routes = [
  {
    path: '/HomeConsumer/:device_group_id',
    name: 'HomeConsumer',
    component: HomeConsumer,
    meta: {
      title: 'home',
      icon: 'mdi-home',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/HomeAdmin/:device_group_id',
    name: 'HomeAdmin',
    component: HomeAdmin,
    meta: {
      title: 'home',
      icon: 'mdi-home',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/AlermHistory/d/:device_group_id?/m/:model_id?/s/:serial_no?/g/:group_id?',
    name: 'AlermHistory',
    component: AlermHistory,
    meta: {
      title: 'alarmRecords',
      icon: 'mdi-alert-circle',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/DashboardAdmin/d/:device_group_id',
    name: 'DashboardAdmin',
    component: DashboardAdmin,
    meta: {
      title: 'dashboard',
      icon: 'mdi-monitor-dashboard',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'login',
      icon: 'mdi-login',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/CompressorInfo/:model_id/:serial_no',
    name: 'CompressorInfo',
    component: CompressorInfo,
    props: true,
    meta: {
      title: 'machineInformation',
      icon: 'machineInfo',
      colors: ['#FFFFFF'],
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/TrendGraph/:model_id/:serial_no',
    name: 'TrendGraph',
    component: TrendGraph,
    meta: {
      title: 'sensorTrendGraph',
      icon: 'trendGraph',
      colors: ['#FFFFFF', '#FFFFFF', '#FFFFFF'],
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/InfoSetting',
    name: 'InfoSetting',
    component: InfoSetting,
    meta: {
      title: 'manageNotifications',
      icon: 'mdi-information ',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/GroupingSetting',
    name: 'GroupingSetting',
    component: GroupingSetting,
    meta: {
      title: 'machineGroupSettings',
      icon: 'mdi-account-group',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/MachineNumberSetting',
    name: 'MachineNumberSetting',
    component: MachineNumberSetting,
    meta: {
      title: 'customerSMachineNo',
      icon: 'machineInfo',
      colors: ['#FFFFFF'],
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/AlermMailSetting/d/:device_group_id?/g/:group_id?/n/:device_group_name_locale?/m/:model_id?/s/:serial_no?',
    name: 'AlermMailSetting',
    component: AlermMailSetting,
    meta: {
      title: 'alarmNotificationEmailSettings',
      icon: 'mdi-email',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/MaintenanceHistory/:model_id/:serial_no',
    name: 'MaintenanceHistory',
    component: MaintenanceHistory,
    meta: {
      title: 'maintenanceRecords',
      icon: 'maintenanceHistory',
      colors: ['#FFFFFF', '#1565C0'],
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/VolumeGraph/d/:device_group_id?/m/:model_id?/s/:serial_no?/g/:group_id?',
    name: 'VolumeGraph',
    component: VolumeGraph,
    meta: {
      title: 'dischargeAirVolumePowerConsumptionGraph',
      icon: 'powerConsumption',
      colors: ['#FFFFFF', '#1565C0'],
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/MonthlyReport/:device_group_id/:group_id',
    name: 'MonthlyReport',
    component: MonthlyReport,
    meta: {
      title: 'monthlyReport',
      icon: 'mdi-file-document-multiple-outline',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/',
    name: 'Root',
    meta: {
      title: '',
      icon: '',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: '不正なURL',
      icon: '',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/ConsumerMap',
    name: 'ConsumerMap',
    component: ConsumerMap,
    meta: {
      title: 'consumerMap',
      icon: 'mdi-google-maps',
      from: {
        name: '',
        path: '',
      },
    },
  },
  {
    path: '/Logs',
    name: 'Logs',
    component: Logs,
    meta: {
      title: 'logging',
      icon: 'mdi-file-find-outline',
      from: {
        name: '',
        path: '',
      },
    },
  },
];

const router = new Router({
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // to.nameがLoginの場合, またはtokenStatus()がtrueの場合はそのまま遷移
  if (to.name === 'Login' || tokenStatus()) {
    next();
  } else {
    if (to.path !== '/Login') {
      // URLを直接指定したが、認証が済んでいないとき
      // いったん元のURLをセッションストレージに保存しておく
      if (from.name === null && to.name !== 'Root') {
        sessionStorage.setItem('prevPath', JSON.stringify(to));
      }
      next({ path: '/Login' });
    } else {
      next();
    }
  }
});

const tokenStatus = () => {
  const vueIns = new Vue();
  if (process.env.NODE_ENV === 'production') {
    return vueIns.$msal.isAuthenticated();
  } else {
    return Boolean(store.getters['auth/access_token']);
  }
};

export default router;
